import React, { FC } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import InputB from '@mui/material/InputBase';
import ThemeCompatibleIcon from 'src/components/shared/molecules/themeCompatibleIcon/ThemeCompatibleIcon';
import CallendarIcon from 'src/assets/ikona_kalendarz.svg';
import { useTheme } from '@mui/material/styles';
import { UiInputNormalProps } from '../types';
import { UiInputElWrapper } from 'src/components/shared/atoms/uiInputs/uiInputElements/uiInputElWrapper/UiInputElWrapper';
import { UiInputElLabel } from 'src/components/shared/atoms/uiInputs/uiInputElements/uiInputElLabel/UiInputElLabel';
import { sxInputV1Default, sxThemeCompatibleIconV1Default } from '../sxDefault';

export const UiInputNormal: FC<UiInputNormalProps> = (props) => {
    const { typeIcon = 'svg' } = props;
    const theme = useTheme();

    const sxinput = {
        border: `solid 1px ${theme.palette.primary.main}`,
        ...sxInputV1Default,
        ...props.sxinput
    };
    const sxthemecompatibleicon = {
        ...sxThemeCompatibleIconV1Default,
        ...props.sxthemecompatibleicon
    };
    if (props.isicon === 'true') {
        return (
            <UiInputElWrapper {...props}>
                {props.label && <UiInputElLabel {...props} />}
                <InputB
                    sx={sxinput}
                    style={{
                        WebkitAppearance: 'none'
                    }}
                    endAdornment={
                        typeIcon === 'svg' ? (
                            <InputAdornment position="end" sx={props.sxinputadornment}>
                                <ThemeCompatibleIcon
                                    SvgComponent={props.icon ? props.icon : CallendarIcon}
                                    fontSize={'medium'}
                                    sx={sxthemecompatibleicon}
                                />
                            </InputAdornment>
                        ) : (
                            <InputAdornment position="end" sx={props.sxinputadornment}>
                                {props.iconComponent}
                            </InputAdornment>
                        )
                    }
                    {...props}
                />
            </UiInputElWrapper>
        );
    }
    return (
        <UiInputElWrapper {...props}>
            {props.label && <UiInputElLabel {...props} />}
            <InputB sx={sxinput} {...props} />
        </UiInputElWrapper>
    );
};
